import { useQuery } from '@tanstack/react-query'
import { useWorkspace } from 'components/providers'
import { createContext, useState } from 'react'
import { useParams } from 'react-router'
import { DCFilter } from 'types'
import { getAggregations, useUser } from 'utils'

export interface OnTheGoContextProps {
  memberId: string
  memberName: string
  filters?: DCFilter[]
  sessionCount: number
  sessionCountLoading: boolean
  setFilters: (filters: DCFilter[]) => void
}

export const OnTheGoContext = createContext<OnTheGoContextProps>({} as any)

export function OnTheGoProvider({ children }: { children: any }) {
  const { id: memberId = '' } = useParams<{ id: string }>()
  const { workspace } = useWorkspace()
  const member = useUser(memberId)
  const [filters, setFilters] = useState<DCFilter[]>([])
  const { data: sessionCount = 0, isLoading: sessionCountLoading } = useQuery({
    enabled: Boolean(workspace?.id) && Boolean(memberId),
    queryFn: async () => {
      const response = await getAggregations({
        aggregations: [
          {
            filters: [
              { field: 'createdBy', operator: 'eq', table: 'leadSessions', value: memberId },
              { field: 'eventId', operator: 'isNull', table: 'leadSessions', value: true },
            ],
            table: 'leadSessions',
            values: ['_count'],
          },
        ],
        workspaceIds: workspace?.id ? [workspace.id] : undefined,
      })
      return Number(response.data?.[0]?.[0]?._count) || 0
    },
    queryKey: ['onTheGoMemberSessionCount', workspace?.id, memberId],
    staleTime: 1000 * 60,
  })

  return (
    <OnTheGoContext.Provider
      value={{
        memberId,
        memberName: member?.displayName ?? '',
        filters,
        sessionCount,
        sessionCountLoading,
        setFilters,
      }}
    >
      {children}
    </OnTheGoContext.Provider>
  )
}
